import React, { useState, useEffect } from 'react';
// import { Grid } from '@material-ui/core';
import moment from 'moment';
import ReactApexChart from 'react-apexcharts';
import { Options, createBarRadiusZoomHandler, computeBarRadius } from './graphOptions';
import { getCountsWithComma } from '../../../../commons/util/utilities';
import SkeletonLoader from '../../../../components/SkeletonLoader';
import { buildChartTooltip } from '../chartTooltip';
import { useChartTooltipStyles as useStyles } from '../chartTooltip/styles';

// components
// import Widget from '../../../components/Widget/Widget';

// const values = {
//   series: [
//     {
//       data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380, 400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380, 400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
//     },
//   ],
// };

export default function Charts (props) {
  const classes = useStyles();
  const { baseRadius = 5 } = props;
  const [values, setValues] = useState([]);
  const [options, setOptions] = useState(() => ({
    ...Options,
    plotOptions: {
      ...Options.plotOptions,
      bar: { ...Options.plotOptions.bar, borderRadius: baseRadius },
    },
  }));

  const subscriptions = props.data;

  const getDates = (data) => data.map(({ date }) => date);
  const getValues = (data) => data.map(({ count }) => count);

  useEffect(() => {
    if (subscriptions) {
      const newSubscriptions = JSON.stringify(subscriptions);
      const formattedData = getCountsWithComma(JSON.parse(newSubscriptions));
      
      const dates = getDates(subscriptions).map((date) => new Date(date).getTime());
      const totalRange = Math.max(...dates) - Math.min(...dates);
      const initialRadius = computeBarRadius({
        dataLength: subscriptions.length,
        baseRadius,
        maxRadius: 40,
      });

      setOptions({
        ...options,
        plotOptions: {
          ...options.plotOptions,
          bar: { ...options.plotOptions.bar, borderRadius: initialRadius },
        },
        xaxis: {
          categories: getDates(subscriptions),
          type: 'datetime',
        },
        chart: {
          ...options.chart,
          events: {
            zoomed: createBarRadiusZoomHandler(totalRange, {
              baseRadius: initialRadius,
              maxRadius: 40,
            }),
          },
        },
        tooltip: {
          ...options.tooltip,
          custom: ({ dataPointIndex }) => {
            const point = formattedData?.[dataPointIndex];
            if (!point) return '';
            return buildChartTooltip({
              label: moment(point.date).format('DD MMM').toUpperCase(),
              count: point.count,
              sublabel: 'New subs',
            });
          },
        },
      });
      setValues([{ data: getValues(subscriptions) }]);
    }
  }, [subscriptions, baseRadius]);

  return (
    <>
      {props.isLoading && !subscriptions?.length
? (
        <SkeletonLoader />
      )
 : (
        <div className={classes.chartWrapper}>
          <ReactApexChart
            options={options}
            series={values}
            type='bar'
            height='350'
          />
        </div>
      )}
    </>
  );
}
